export default __webpack_public_path__ + "locales/sr-Latn-RS/InviteDialog.json?hash=d49269ba9dd8be0eda96a4456d03d014";